import axios from 'axios'
import '@/api'
import { extract } from './utils'
import { merge } from 'lodash'

// ------------------------------------
// Endpoint Configuration
// ------------------------------------

const endpointConfig = {
  url: '/report/orderItemsPlaced'
}

// ------------------------------------
// Initial State
// ------------------------------------

const state = {
  orderItemsPlaced: []
}

// ------------------------------------
// Getters
// ------------------------------------

const getters = {
  orderItemsPlaced: state => state.orderItemsPlaced
}

// ------------------------------------
// Constants
// ------------------------------------

const REQUEST_GET_ORDER_ITEMS_PLACED = 'REQUEST_GET_ORDER_ITEMS_PLACED'
const RECEIVE_GET_ORDER_ITEMS_PLACED = 'RECEIVE_GET_ORDER_ITEMS_PLACED'

// ------------------------------------
// Actions
// ------------------------------------

const actions = {
  async getOrderItemsPlaced ({ commit, dispatch }, { includes = undefined, filters = undefined, sort = undefined }) {
    dispatch('wait/start', 'getting orderItemsPlaced', { root: true })
    commit(REQUEST_GET_ORDER_ITEMS_PLACED)
    const config = merge({}, endpointConfig, { params: merge({}, filters, { include: includes }, { sort: sort }) })
    return axios.get(endpointConfig.url, config)
      .then((response) => {
        dispatch('receiveOrderItemsPlaced', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting orderItemsPlaced', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting orderItemsPlaced', { root: true })
        return Promise.reject(error)
      })
  },
  receiveOrderItemsPlaced ({ commit, dispatch }, [ json, action ]) {
    commit(`RECEIVE_${action}_ORDER_ITEMS_PLACED`, extract(json))
    return json.data
  },
}

// ------------------------------------
// Mutations
// ------------------------------------

const mutations = {
  [REQUEST_GET_ORDER_ITEMS_PLACED](state, id) {
  },
  [RECEIVE_GET_ORDER_ITEMS_PLACED](state, json) {
    state.orderItemsPlaced = json
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
